module.exports = __webpack_public_path__ + "img/13_26.4a5bec6b.png";